import { Component } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent {

  constructor() {}
}
